import { Create } from "@components/modules/invoices/Create";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { RequestForInvoicingNavigation } from "@src/components/widgets/AppSubNav/navigation-invoices/requests-for-invoicing";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout
    title={t`Create request for invoicing`}
    navigation={<RequestForInvoicingNavigation />}
  >
    <Create.Outgoing />
  </MainLayout>
);

export const Route = createFileRoute("/invoices/for-invoicing/create-invoice")({
  component: Page,
});
